import { Component } from '@angular/core';

@Component({
  selector: 'data-lens-loader',
  imports: [

  ],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {

}
